import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Facebook",
  "use": "Facebook-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Facebook\"><path d=\"M45.69 26.167L44.33 37.5h-7.163v25h-13v-25H17.5V26.167h6.667v-3.5c0-7.796 4.692-13.167 13.166-13.167H45.5v11.333h-5.833c-2.339 0-2.5.162-2.5 1.834v3.5h8.524z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol